import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { MiscService } from 'app/shared/misc.service';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { CustomerService } from '../customers.service';
import * as customerActions from './customers.actions'

@Injectable({
    providedIn: 'root'
})

export class CustomerEffects {
    constructor(
        private actions$: Actions,
        private customerService: CustomerService,
        private toastr: ToastrService,
        private miscService: MiscService
    ) {}

    fetchServiceTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(customerActions.fetchServiceTypes),
      exhaustMap((action) =>
        this.customerService
          .getServiceTypes()
          .pipe(
            exhaustMap((response: any) => [
                customerActions.fetchServiceTypesSuccess({ serviceTypes: response}),
            ]),
            catchError((error: HttpErrorResponse) => {
                this.toastr.error(error.error?.message, 'An error occured');
                return of(customerActions.fetchServiceTypesFailed())
            }
            )
          )
      )
    )
  );

    createServiceType$ = createEffect(() =>
    this.actions$.pipe(
      ofType(customerActions.createServiceType),
      exhaustMap((action) =>
        this.customerService
          .createServiceType(action.serviceTypeDto)
          .pipe(
            exhaustMap((response: any) => [
                customerActions.createServiceTypeSuccess(),
            ]),
            catchError((error: HttpErrorResponse) => {
                this.toastr.error(error.error?.message, 'An error occured');
                return of(customerActions.createServiceTypeFailed())
            }
            )
          )
      )
    )
  );

    updateServiceType$ = createEffect(() =>
    this.actions$.pipe(
      ofType(customerActions.updateServiceType),
      exhaustMap((action) =>
        this.customerService
          .updateServiceType(action.serviceTypeDto, action.serviceTypeId)
          .pipe(
            exhaustMap((response: any) => [
                customerActions.updateServiceTypeSuccess(),
            ]),
            catchError((error: HttpErrorResponse) => {
                this.toastr.error(error.error?.message, 'An error occured');
                return of(customerActions.updateServiceTypeFailed())
            }
            )
          )
      )
    )
  );

    deleteServiceType$ = createEffect(() =>
    this.actions$.pipe(
      ofType(customerActions.deleteServiceType),
      exhaustMap((action) =>
        this.customerService
          .deleteServiceType(action.serviceTypeId)
          .pipe(
            exhaustMap((response: any) => [
                customerActions.deleteServiceTypeSuccess(),
            ]),
            catchError((error: HttpErrorResponse) => {
                this.toastr.error(error.error?.message, 'An error occured');
                return of(customerActions.deleteServiceTypeFailed())
            }
            )
          )
      )
    )
  );


  fetchCustomerTypes$ = createEffect(() =>
  this.actions$.pipe(
    ofType(customerActions.fetchCustomerTypes),
    exhaustMap((action) =>
      this.customerService
        .getCustomerTypes()
        .pipe(
          exhaustMap((response: any) => [
              customerActions.fetchCustomerTypesSuccess({ customerTypes: response}),
          ]),
          catchError((error: HttpErrorResponse) => {
              this.toastr.error(error.error?.message, 'An error occured');
              return of(customerActions.fetchCustomerTypesFailed())
          }
          )
        )
    )
  )
);


createCustomerType$ = createEffect(() =>
this.actions$.pipe(
  ofType(customerActions.createCustomerType),
  exhaustMap((action) =>
    this.customerService
      .createCustomerType(action.customerTypeDto)
      .pipe(
        exhaustMap((response: any) => [
            customerActions.createCustomerTypeSuccess(),
        ]),
        catchError((error: HttpErrorResponse) => {
            this.toastr.error(error.error?.message, 'An error occured');
            return of(customerActions.createCustomerTypeFailed())
        }
        )
      )
  )
)
);

updateCustomerType$ = createEffect(() =>
this.actions$.pipe(
  ofType(customerActions.updateCustomerType),
  exhaustMap((action) =>
    this.customerService
      .updateCustomerType(action.customerTypeDto, action.customerTypeId)
      .pipe(
        exhaustMap((response: any) => [
            customerActions.updateCustomerTypeSuccess(),
        ]),
        catchError((error: HttpErrorResponse) => {
            this.toastr.error(error.error?.message, 'An error occured');
            return of(customerActions.updateCustomerTypeFailed())
        }
        )
      )
  )
)
);

deleteCustomerType$ = createEffect(() =>
this.actions$.pipe(
  ofType(customerActions.deleteCustomerType),
  exhaustMap((action) =>
    this.customerService
      .deleteCustomerType(action.customerTypeId)
      .pipe(
        exhaustMap((response: any) => [
            customerActions.deleteCustomerTypeSuccess(),
        ]),
        catchError((error: HttpErrorResponse) => {
            this.toastr.error(error.error?.message, 'An error occured');
            return of(customerActions.deleteCustomerTypeFailed())
        }
        )
      )
  )
)
);


fetchCustomers$ = createEffect(() =>
this.actions$.pipe(
  ofType(customerActions.fetchCustomers),
  exhaustMap((action) =>
    this.customerService
      .getCustomersWithServiceType(action.serviceTypeId)
      .pipe(
        exhaustMap((response: any) => [
            customerActions.fetchCustomersSuccess({ customers: response}),
        ]),
        catchError((error: HttpErrorResponse) => {
            this.toastr.error(error.error?.message, 'An error occured');
            return of(customerActions.fetchCustomersFailed())
        }
        )
      )
  )
)
);

createCustomerSingle$ = createEffect(() =>
this.actions$.pipe(
  ofType(customerActions.createCustomerSingle),
  exhaustMap((action) =>
    this.customerService
      .createCustomerSingleWithServiceType(action.customerDto, action.customerTypeId)
      .pipe(
        exhaustMap((response: any) => [
            customerActions.createCustomerSingleSuccess(),
        ]),
        catchError((error: HttpErrorResponse) => {
            this.toastr.error(error.error?.message, 'An error occured');
            return of(customerActions.createCustomerSingleFailed())
        }
        )
      )
  )
)
);

createCustomerBulk$ = createEffect(() =>
this.actions$.pipe(
  ofType(customerActions.createCustomerBulk),
  exhaustMap((action) =>
    this.customerService
      .createCustomerBulkWithServiceType(action.customerDto, action.customerTypeId)
      .pipe(
        exhaustMap((response: any) => [
            customerActions.createCustomerBulkSuccess(),
        ]),
        catchError((error: HttpErrorResponse) => {
            this.toastr.error(error.error?.message, 'An error occured');
            return of(customerActions.createCustomerBulkFailed())
        }
        )
      )
  )
)
);


}